import Axios from "@app/api/axios";

import { CASES } from "@utils/constant";

export const getCasesListService = (query = "") => {
  return Axios.get(`${CASES}${query}`).then(response => response.data);
};
